<template>
  <div>
    <v-layout v-if="tender.status === 'draft'" wrap>
      <v-flex xs6 @click="navigateToEditMyTender(tender.id)">
        <v-btn text>
          <v-icon>edit</v-icon>
          <span class="pl-2">
            <translate>edit</translate>
          </span>
        </v-btn>
      </v-flex>
      <v-flex xs6 @click="publishTender(tender.id)">
        <v-btn text>
          <v-icon>mdi-printer</v-icon>
          <span class="pl-2">
            <translate>Publish</translate>
          </span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="isTenderPublishable">
      <v-btn text @click="cancelTenderPublishing(tender.id)">
        <v-icon>mdi-cancel</v-icon>
        <span class="pl-2">cancel</span>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import TenderApi from '@/services/apiCalls/tenders/tenders'
import ErrorHandler from '@/utils/ErrorHandler.js'
export default {
  name: 'TenderDetailTenderActions',

  props: {
    tender: {
      type: null,
    },
    getTender: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      tenderHasBeenCanceled: false,
      updateTender: null,
    }
  },

  // created() {
  //     const a = this.$moment()
  //     const b = this.$moment()
  // },

  watch: {
    tender(value) {
      if (value) {
        this.tenderHasBeenCanceled = value.status === 'canceled'
      }
    },
  },

  computed: {
    isTenderPublishable() {
      if (this.tender && this.tender.status && !this.tenderHasBeenCanceled) {
        const statuses = ['active.tendering', 'active.qualification', 'active.awarded']

        return statuses.includes(this.tender.status)
      }
      return false
    },
    tendeEndDateValidity() {
      if (
        !this.tender.tenderPeriod ||
        (this.tender.tenderPeriod && !this.tender.tenderPeriod.endDate)
      ) {
        return true
      } else {
        const endDate = this.$moment(this.tender.tenderPeriod.endDate)
        const todayDate = this.$moment()
        const timeDiff = this.$moment.duration(endDate.diff(todayDate)).as('milliseconds')

        return timeDiff <= 0
      }
    },
  },

  methods: {
    navigateToEditMyTender(id) {
      this.$router.push({ name: 'editmytender', params: { id } })
    },
    publishTender() {
      if (this.tendeEndDateValidity) {
        this.$store.commit('openSnackBar', {
          text: this.$gettext('Enter valid Bid submission deadline before publication.'),
          color: 'warning',
        })
      }
      if (!this.tender.items || !this.tender.items.length) {
        this.$store.commit('openSnackBar', {
          text: this.$gettext('Add at least one item to this tender before publication.'),
          color: 'warning',
        })
      }
      if (
        !this.tendeEndDateValidity &&
        (this.tender.items || (this.tender.items && this.tender.items.length))
      ) {
        this.openPublishConfirmDialog();
      }
    },

    async openPublishConfirmDialog() {
      const res = await this.$root.openConfirmDialog({
        cardTitle: 'Submission Confirmation',
        cardText: 'Please confirm that you want to electronically sign and submit your Tender notice',
        cancelButtonText: "don't submit tender notice",
        approveButtonText: 'submit tender notice now',
      });
      if (res) {
        this.confirmTenderPublication(this.tender.id);
      }
    },

    async confirmTenderPublication() {
      this.$store.commit('spinner', true)
      try {
        await TenderApi.publishTender(this.$route.params.id)

        // this.$store.commit('setCurrentTenderType', 'myTenders')

        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been submitted for publication.'),
          color: 'success',
        })
        this.updateTender = setInterval(this.updateDataTender, 3000)
        this.$store.commit('spinner', false)
      } catch (err) {
        this.$store.commit('spinner', false)
        ErrorHandler(err, this)
      }
    },
    async cancelTenderPublishing() {
      this.$store.commit('spinner', true)
      try {
        await TenderApi.cancelTender(this.$route.params.id)

        // this.$store.commit('setCurrentTenderType', 'myTenders')

        this.$store.commit('openSnackBar', {
          text: this.$gettext('The tender has been submitted for cancellation.'),
          color: 'success',
        })
        this.tenderHasBeenCanceled = true

        this.updateTender = setInterval(this.updateDataTender, 3000)

        this.$store.commit('spinner', false)
      } catch (err) {
        this.$store.commit('spinner', false)
        ErrorHandler(err, this)
      }
    },
    updateDataTender() {
      this.getTender()
      if (this.tender.status == 'active.tendering' || this.tender.status == 'cancelled') {
        clearInterval(this.updateTender)
        this.$store.commit('openSnackBar', {
          text: this.$gettext('The information about the tender has been updated.'),
          color: 'info',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-btn {
  padding: 0;
}
</style>
